<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.given_name + ' ' + recordData.family_name : ''}}</h1>
      </div>
    </div>
    <template
      v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]">

        <md-tab id="tab-account" md-label="Salesrep" :to="recordPath" exact>
          <div class="md-card md-layout-item md-small-size-100" >
          <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
          </div>
        </md-tab>
        <md-tab id="tab-cases" md-label="Cases" :to="recordPath + '/cases'">
          <CaseTab
            v-if="$route && $route.meta.tab === 'cases'" 
            :routeParamsId= "$route.params.id" 
            :caseListData= "casesList"
            :caseMapFilter="caseSalesrepIdFilter"
            :relateRecordInput="caseServiceRelateRecordInput"
          />
        </md-tab>
        <md-tab id="tab-tasks" md-label="Tasks" :to="recordPath + '/tasks'">
          <TaskTab
            v-if="$route && $route.meta.tab === 'tasks'" 
            :routeParamsId= "$route.params.id" 
            :taskListData= "tasksList"
            :filter="taskSalesrepIdFilter"
          />
        </md-tab>

      </md-tabs>
    </template>

    <div v-else class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]"> 
      <div class="md-content md-tabs-content md-theme-default">
        <div class="md-tabs-container">
          <div id="tab-active" class="md-tab">
            <div class="md-card md-layout-item md-small-size-100">
              <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import Page from '@/mixins/Page';

  // Form validations
  import { required, numeric, minLength, email } from "vuelidate/lib/validators";
  import { CustomPhoneValidator } from "@/plugins/vuelidate/custom-phone-validator";
  import CaseTab from '@/components/CaseTab';
  import TaskTab from '@/components/TaskTab';

  export default {
    name: "salesrep",
    mixins: [Record, Page],
    components: {
      CaseTab,
      TaskTab
    },
    computed: {
      caseServiceRelateRecordInput: function() { return {'caseSalesRepCaseId': null, 'caseSalesRepSalesrepId': this.$route.params.id}},
      caseSalesrepIdFilter: function() { return {"match": {"caseSalesRepSalesrepId": this.$route.params.id }}; },
      taskSalesrepIdFilter: function() { return {"match": {"taskSalesRepSalesrepId": this.$route.params.id }}; }
    },
    data() {
      return {
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'salesRepUpdatedById',
          responseFieldName: 'getSalesRep',
          actions: {
            save: 'createSalesRep',
            view: 'editSalesRep',
            edit: 'editSalesRep',
            new: 'newSalesRep',
            update: 'updateSalesRep',
            delete: 'deleteSalesRep',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":12,"i":"0"}},
            contact: {label: 'Contact Information', icon: 'work', layout: {"x":0,"y":12,"w":12,"h":12,"i":"1"}},
          },
          listPath: "/salesreps",
          headerIcon: 'assignment_ind',
          objectName: 'SalesRep',
          objectNamePlural: 'SalesReps',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            given_name: { label: "First Name", type: "text", slot: 'basic' },
            family_name: { label: "Last Name", type: "text", slot: 'basic' },
            nickname: { label: "Nick Name", type: "text", slot: 'basic' },
            email: { label: "Email", type: "text", slot: 'basic' },
            website: { label: "Website", type: "text", slot: 'basic' },
            phone_number: { label: "Phone", type: "text", slot: 'basic' },
            addressMailing: {
              label: "Mailing Address",
              type: "json",
              slot: 'contact',
              fields: {
                street_address: { label: "Street Address", type: "text", slot: 'contact' },
                locality: { label: "City", type: "text", slot: 'contact' },
                region: { label: "State", type: "select", slot: 'contact', optionType: 'enum', options: []}, //State
                postal_code: { label: "Postal Code", type: "text", slot: 'contact' },
                country: {label: "Country", type: "select", slot: "contact", optionType: 'enum', options: []},
              }
            },
            description: { label: "Description", type: "text", slot: 'basic' },
            premier: { label: "Premier", type: "checkbox", slot: 'basic' },
            cognito_userid: { label: "cognito_userid", type: "text", slot: 'basic' },
            createdAt: { label: "Created", type: "id", slot: 'basic' },
            updatedAt: { label: "Updated", type: "id", slot: 'basic' },
          },
          editTitleField: 'name'
        },
        form: {
          id: "",
          given_name: "",
          family_name: "",
          nickname: "",
          email: "",
          website: "",
          phone_number: "",
          accountType: "",
          ownershipType: "",
          addressMailing: {
            fields: {
              street_address: "",
              locality: "",
              region: "",
              postal_code: "",
              country: "",
            }
          },
          description: "",
          premier: "",
          cognito_userid: "",
          createdAt: "",
          updatedAt: ""
        },
        isValidPhoneNumber: true,
        casesList: {
          listQueryId: "searchCaseSalesRepsCustom",
          responseFieldName: "searchCaseSalesReps",
          listQueryTarget: "searchCaseSalesReps",
          deleteQueryId: "deleteCaseSalesRep",
          deleteMessageNameFields: ['subject'],
          filterListQueryId: "getListCaseStatusEnum",
          relateRecordInputField:"caseSalesRepCaseId",
          createMutationId: "createCaseSalesRep",
          caseFromTab: 'SalesRep',
        },
        tasksList: {
          listQueryId: "searchTaskSalesReps",
          // responseFieldName: "searchTaskAccounts",
          deleteQueryId: "deleteTaskSalesRep",
          filterListQueryId: "getListTaskStatusEnum",
          // caseMapIdFilter: {"taskSalesRepSalesrepId": {"eq": this.$route.params.id }}
        },
        regionOptions: [],
        countryOptions: [],
        mailingCountry: ""
      }
    },
    validations() {
      return {
        form: {
          id: {},
          given_name: {required, minLength: minLength(3)},
          family_name: {required, minLength: minLength(3)},
          nickname: {},
          email: {required, email, minLength: minLength(3)},
          website: {},
          phone_number: {required, minLength: minLength(6), isValid: () => this.isValidPhoneNumber},
          addressMailing: {
              fields: {
                street_address: {required},
                locality: {required},
                region: {required},
                postal_code: {required},
                country: {required},
              }
          },
          description: {},
          premier: {},
          cognito_userid: {},
          createdAt: {},
          updatedAt: {}
        }
      }
    },
    methods: {
      updateFormAfter(data) {
        if (typeof data === 'undefined') return;

        //State and Country dropdown options
        this.getRegionEnumOptions(data);
        this.getCountryEnumOptions(data);
      },
      /**
       * ATLAS-848 Make "State" a drop down and not an open field
       * Methods for State & Country dropdown
       */
      getRegionEnumOptions(data) {
        this.regionOptions = [];

        if (data.listStatesEnum && data.listStatesEnum.enumValues) {
          data.listStatesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.regionOptions.push({
              id: _value.name,
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          this.formConfig.fields.addressMailing.fields.region.options = this.regionOptions;
        }
      },
      getCountryEnumOptions(data) {
        this.countryOptions = [];

        if (data.listCountriesEnum && data.listCountriesEnum.enumValues) {
          data.listCountriesEnum.enumValues.map(_value => {
            let _name = _value.name.replace(/US_|CA_/g, '');
            this.countryOptions.push({
              id: _value.name.replace(/_United_States|_Canada/g,''),
              name: _name.replace(/\_/g, ' ')
            });
          });
          
          this.formConfig.fields.addressMailing.fields.country.options = this.countryOptions;
        }
      }
    },
    watch: {
      /**
       * Look for API errors
       * If mobile number is invalid then we wil get an API error response
       */
      'formConfig.formErrors': {
        handler: function() {
          let isValid = true;
          const errors = this.$reduce(this, 'formConfig.formErrors.errors');
          if (errors && errors.length) {
            errors.forEach(_error => {
              if (_error && _error.message && _error.message.match(/phone_number/ig)) {
                isValid = false;
              }
            });
          }
          this.isValidPhoneNumber = isValid;
        }
      },
      /**
       * When form value is changed - reset phone error
       */
      'form.phone_number': {
        handler: function() {
          this.isValidPhoneNumber = true;
        }
      },
      /**
       * ATLAS-848 Make "State" a drop down and not an open field
       * 
       * Following four watchers will set the Country based on State selection &
       * load specific State list based on Country selection
       */
      "$v.form.addressMailing.fields.region.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressMailing.fields.region) {
            let countryCode = this.form.addressMailing.fields.region.split("_");
            this.form.addressMailing.fields.country = countryCode[0];
          }
        }                       
      },
      "$v.form.addressMailing.fields.country.$model": {
        immediate: true,
        handler: function() {
          if (this.form.addressMailing.fields.country) {
            if (this.mailingCountry && this.mailingCountry != this.form.addressMailing.fields.country) {
              this.form.addressMailing.fields.region = "";
            }

            let newRegionOpts = [];
            this.regionOptions.forEach(item => {
              if(item.id.includes(this.form.addressMailing.fields.country + "_")) {
                newRegionOpts.push(item);
              }
            });

            this.mailingCountry = this.form.addressMailing.fields.country;
            this.formConfig.fields.addressMailing.fields.region.options = newRegionOpts;
          }
        }                       
      }
    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;
    .md-tab-nav-button.md-button {
        color: black !important;

        &.active {
          color: black !important;
          border-bottom: 2px solid black;
        }
      }
    }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

</style>
